/**
 * axios实例
 */
import axios from 'axios'
import {Message} from 'element-ui'
import {API_BASE_URL} from "@/config/setting";

const service = axios.create({
    baseURL: API_BASE_URL
});

/* 请求拦截器 */
service.interceptors.request.use((config) => {
    return config;
}, (error) => {
    return Promise.reject(error);
});

/* 响应拦截器 */
service.interceptors.response.use((res) => {
    if (res.data.code && res.data.code !== 0) {
        Message.error(res.data.message)
    }
    return res.data;
}, (error) => {
    return Promise.reject(error);
});

export default service;